export default function ModelPerformance() {
  return (
    <div className="animate-slide-up">
      <div className="page-header">
        <h1 className="page-title">Model Performance</h1>
        <p className="page-subtitle">AI model accuracy and performance metrics.</p>
      </div>
      <p className="text-muted-foreground">Coming soon.</p>
    </div>
  );
}
